import { NavigationEntry, NavBadgeCounts } from '../../_types/navigation'
import { isEmbeddedExperience } from '../../_utilities/embed-context'

const SEARCH_NAV_ENTRIES: NavigationEntry[] = [
  { to: '/dashboard', label: 'Home' },
  { to: '/discover', label: 'Discover' },
  { to: '/saved-listings', label: 'Saved' },
  {
    to: '/saved-searches',
    label: 'Searches',
    badgeKey: 'preferenceMatchCount',
  },
  { to: '/messages', label: 'Messages', badgeKey: 'unreadMessages' },
  { to: '/profile', label: 'Profile' },
  { to: '/help', label: 'Help' },
]

/**
 * Returns the search-land navigation entries for the current surface.
 * Discover is QuickPass's own listing-browser, so it is dropped when the app
 * is running embedded inside a host site — surfacing it there makes QuickPass
 * feel like a competing product squatting in the partner's page. The
 * standalone app keeps the full list.
 *
 * @returns {NavigationEntry[]} the navigation entries to render
 */
const getSearchNavEntries = (): NavigationEntry[] => {
  if (isEmbeddedExperience() === true) {
    return SEARCH_NAV_ENTRIES.filter(entry => entry.to !== '/discover')
  }

  return SEARCH_NAV_ENTRIES
}

const RESIDENT_NAV_ENTRIES: NavigationEntry[] = [
  { to: '/my-home', label: 'Home', badgeKey: 'residentMessagesUnread' },
  { to: '/payments', label: 'Payments' },
  { to: '/maintenance', label: 'Maintenance' },
  { to: '/announcements', label: 'Announcements' },
  { to: '/documents', label: 'Documents' },
  { to: '/polls', label: 'Polls' },
  { to: '/amenities', label: 'Amenities' },
  { to: '/community', label: 'Community' },
  { to: '/help', label: 'Help' },
]

/**
 * Resolves the live badge count for a navigation entry from the current
 * notification + message tallies. Shared by the desktop inline nav and the
 * mobile drawer so the badge logic lives in exactly one place.
 *
 * @param {NavigationEntry} entry - the navigation entry being rendered
 * @param {NavBadgeCounts} counts - the current badge tallies
 * @returns {number} the count to display, or 0 when the entry has no badge
 */
const resolveNavBadgeCount = (
  entry: NavigationEntry,
  counts: NavBadgeCounts,
): number => {
  if (entry.badgeKey === 'preferenceMatchCount') {
    return counts.preferenceMatchCount
  }

  if (entry.badgeKey === 'unreadMessages') {
    return counts.unreadMessageCount
  }

  if (entry.badgeKey === 'residentMessagesUnread') {
    return counts.residentMessageUnreadCount
  }

  return 0
}

export {
  SEARCH_NAV_ENTRIES,
  RESIDENT_NAV_ENTRIES,
  getSearchNavEntries,
  resolveNavBadgeCount,
}
